import { useContext } from 'react';

import { TimeframeContext } from '../context';

export const useTimeframe = () => useContext(TimeframeContext);
